import React from "react";
import RightSidebar from "../../components/layouts/admin/Sidebars/rightSidebar/RightSidebar";
import { Outlet } from "react-router-dom";

function Admin() {
  // The sidebar sizes itself (it owns the collapsed state), so main just takes
  // the remaining space. `min-w-0` is what stops wide tables from pushing the
  // layout sideways - the old `w-1/5` + `w-full` pair summed to more than 100%.
  //
  // Mirrors the student Dashboard layout: no nested overflow-y-auto (it made a
  // second scroll container inside an already-scrolling page), logical padding,
  // and pt-[6rem] on mobile to clear the now-fixed menu button. Pages no longer
  // need their own mt-20 to sit below it.
  return (
    <div className="admin text-md flex min-h-screen">
      <RightSidebar />
      <main className="main-wrapper h-auto min-w-0 flex-1 px-2xl pb-4xl pt-[6rem] max-md:px-lg md:pt-xl">
        <Outlet />
      </main>
    </div>
  );
}

export default Admin;
